import { NOTES_MAX_LENGTH } from './app.constants';

export { NOTES_MAX_LENGTH } from './app.constants';

export const DialogDefaultConfig = {
    width: '70%',
    minWidth: '700px',
    disableClose: true
}
